export default "__VITE_ASSET__Bv9RF0Pv__"